var _g, _path, _path2, _path3, _path4, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardPaymentAdded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 71,
    viewBox: "0 0 76 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55744 48.3765L8.39359 19.3745C8.28787 16.74 10.3207 14.5034 12.9424 14.3982L61.1698 12.4628C63.7915 12.3576 66.0184 14.4122 66.1246 17.0578L67.2884 46.0597C67.3941 48.6943 65.3504 50.9313 62.7178 51.037L14.5013 52.9719C11.8687 53.0775 9.66361 51.022 9.55744 48.3765Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81103 29.8357L66.542 27.5189L66.2618 20.5374L8.53086 22.8541L8.81103 29.8357Z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M55.3237 41.2948L58.9831 41.1479C60.5342 41.0857 61.8411 42.2977 61.9036 43.8565C61.9662 45.4152 60.7606 46.728 59.2095 46.7903L55.5501 46.9371C53.999 46.9994 52.6921 45.7874 52.6295 44.2286C52.5779 42.6694 53.7835 41.3566 55.3237 41.2948Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M19.1557 33.4672L56.5251 31.9675L56.4573 30.277L19.0879 31.7766L19.1557 33.4672Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.6207 20.1284L55.9902 18.6288L55.9223 16.9383L18.5529 18.4379L18.6207 20.1284Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.1987,
    cy: 67.0354,
    rx: 30.8199,
    ry: 3.46724,
    fill: "#C7C9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 5.20154,
    y: 11.2717,
    width: 65.2789,
    height: 46.8909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 69.3571,
    y1: -26.2294,
    x2: 21.7241,
    y2: 61.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555804,
    stopColor: "#3067FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936017,
    stopColor: "#074CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FCCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -4.09246,
    y1: 12.1235,
    x2: 76.784,
    y2: 37.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282E49"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardPaymentAdded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CardPaymentAdded.44dca8678d2b0d0c1543417d6f3989b9.svg";